import { defaultButtonTheme } from "../components/Button/theme";
import base from "./base";
import { colors } from "./colors";
import type { CarryTheme, Colors } from "./types";

const darkColors: Colors = {
  // Reversed grayscale for dark theme
  GRAYSCALE_25: colors.GRAYSCALE_900,
  GRAYSCALE_50: colors.GRAYSCALE_800,
  GRAYSCALE_100: colors.GRAYSCALE_700,
  GRAYSCALE_200: colors.GRAYSCALE_600,
  GRAYSCALE_300: colors.GRAYSCALE_500,
  GRAYSCALE_400: colors.GRAYSCALE_400,
  GRAYSCALE_500: colors.GRAYSCALE_300,
  GRAYSCALE_600: colors.GRAYSCALE_200,
  GRAYSCALE_700: colors.GRAYSCALE_100,
  GRAYSCALE_800: colors.GRAYSCALE_50,
  GRAYSCALE_900: colors.GRAYSCALE_25,

  // Primary colors - darker variants for dark theme
  PRIMARY_25: colors.PRIMARY_900,
  PRIMARY_50: colors.PRIMARY_800,
  PRIMARY_100: colors.PRIMARY_700,
  PRIMARY_200: colors.PRIMARY_600,
  PRIMARY_300: colors.PRIMARY_500,
  PRIMARY_400: colors.PRIMARY_400,
  PRIMARY_500: colors.PRIMARY_300,
  PRIMARY_600: colors.PRIMARY_200,
  PRIMARY_700: colors.PRIMARY_100,
  PRIMARY_800: colors.PRIMARY_50,
  PRIMARY_900: colors.PRIMARY_25,

  // Special colors - darker variants for dark theme
  SPECIAL_25: colors.SPECIAL_900,
  SPECIAL_50: colors.SPECIAL_800,
  SPECIAL_100: colors.SPECIAL_700,
  SPECIAL_200: colors.SPECIAL_600,
  SPECIAL_300: colors.SPECIAL_500,
  SPECIAL_400: colors.SPECIAL_400,
  SPECIAL_500: colors.SPECIAL_300,
  SPECIAL_600: colors.SPECIAL_200,
  SPECIAL_700: colors.SPECIAL_100,
  SPECIAL_800: colors.SPECIAL_50,
  SPECIAL_900: colors.SPECIAL_25,

  // Error colors - keep similar but adapt for dark backgrounds
  ERROR_25: colors.ERROR_900,
  ERROR_50: colors.ERROR_800,
  ERROR_100: colors.ERROR_700,
  ERROR_200: colors.ERROR_600,
  ERROR_300: colors.ERROR_500,
  ERROR_400: colors.ERROR_400,
  ERROR_500: colors.ERROR_300,
  ERROR_600: colors.ERROR_200,
  ERROR_700: colors.ERROR_100,
  ERROR_800: colors.ERROR_50,
  ERROR_900: colors.ERROR_25,

  // Warning colors - keep similar but adapt for dark backgrounds
  WARRING_25: colors.WARRING_900,
  WARRING_50: colors.WARRING_800,
  WARRING_100: colors.WARRING_700,
  WARRING_200: colors.WARRING_600,
  WARRING_300: colors.WARRING_500,
  WARRING_400: colors.WARRING_400,
  WARRING_500: colors.WARRING_300,
  WARRING_600: colors.WARRING_200,
  WARRING_700: colors.WARRING_100,
  WARRING_800: colors.WARRING_50,
  WARRING_900: colors.WARRING_25,

  // Keep accent colors the same
  GOLD: colors.GOLD,
  BLUE: colors.BLUE,
  COUPON_BLUE: colors.COUPON_BLUE,
  GREEN: colors.GREEN,
  DARK_ORANGE: colors.DARK_ORANGE,

  // Reverse primitive colors for dark theme
  BLACK: colors.WHITE,
  WHITE: colors.BLACK,

  TRANSPARENT_WHITE_80: "rgba(0, 0, 0, 0.8)",
};

const darkTheme: CarryTheme = {
  ...base,
  colors: darkColors,
  button: defaultButtonTheme,
  backgrounds: {
    primary:
      "linear-gradient(111.98deg, rgba(0, 0, 0, 0.05) 5%, rgba(255, 255, 255, 0.03) 100%)",
    secondary: "#2A2A35",
    secondaryTransparent: "rgba(42, 42, 53, 0.5)",
    theme: "#1D1D26",
  },
};

export default darkTheme;
